import styled from "styled-components"

import ProcessDenyOrder from "components/containers/commerce/order/ProcessDenyOrder";

import TitleHeader from "components/presenters/header/TitleHeader";

export default function ProcessDenyOrderLayout({match}) { 
  const orderNo = match?.params?.orderNo;
  return (
    <Wrapper>
      <HeaderBlock>
        <TitleHeader title={'주문 / 결제'} hideBtn/>
      </HeaderBlock>
      <Content>
					<ProcessDenyOrder orderNo={orderNo}/>
      </Content>
    </Wrapper>
  )
}

const Wrapper = styled.div`
	display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
`;

const HeaderBlock = styled.div`
  flex: 0 1 auto;
  min-height: calc(100vw * (59.68 / 375));
  height: calc(100vw * (60 / 375));
`;

const Content = styled.div`
  flex: 1 1 auto;
  height: 100%;
  /* padding-bottom: calc(100vw * (50 / 375)); */
`;
